import React from "react"
import Row from "antd/lib/row"
import Collapse from "antd/lib/collapse"
import FormInputElem from "./formInputElem"
import { FormMinMaxInterface } from "./form.types"

export default function FormMinMax({ header, inputType, min, max, keyCode = "0" }: FormMinMaxInterface) {
    return (
        <Collapse ghost defaultActiveKey={keyCode}>
            <Collapse.Panel header={header} key={keyCode}>
                <Row gutter={[16, 16]}>
                    <FormInputElem elem={min} inputType={inputType} />
                    <FormInputElem elem={max} inputType={inputType} />
                </Row>
            </Collapse.Panel>
        </Collapse>
    )
}
